import React, { PureComponent } from 'react';
import './WidgetMapaRadar.css';
import { translate } from '../../utils/translations';
import PropTypes from 'prop-types';
import Header from '../../partials/Header/Header';
import logo from '../../img/logo.png';
import Nav from '../../partials/Nav/Nav';
import { Radar } from '../../partials/Radar/Radar';
import RadarLegend from '../../partials/RadarLegend';
import { links } from '../../utils/urls';
import { DateTime } from 'luxon';

export class WidgetMapaRadar extends PureComponent {
    static propTypes = {
        config: PropTypes.shape({
            color: PropTypes.string,
            language: PropTypes.string,
            target: PropTypes.string,
        }),
        data: PropTypes.shape({
            dataSistema: PropTypes.string,
            dataUltimaImatge: PropTypes.string,
        }),
        preview: PropTypes.bool,
        widgetDate: PropTypes.string,
    };

    render() {
        const { preview, config, data, widgetDate } = this.props;
        const { color, language, target } = config;
        return (
            <div
                className="WidgetMapaRadar mc-widget"
                style={{
                    width: !preview ? '100%' : null,
                    height: !preview ? 'calc(100% - 20px)' : null,
                }}
            >
                <Header color={color} logo={logo} target={target} />
                <div
                    className="mc-widget-wrapper"
                    style={{ height: 'calc(100% - 30px)' }}
                >
                    <Nav
                        alternativeTitle={translate(language, 'radar_title')}
                        language={language}
                        alternativeMenu={translate(language, 'radar_nav_link')}
                        linkAlternativeMenu={`${links.baseMeteo}${
                            links.radarObservacions
                        }`}
                        widgetDate={widgetDate}
                        target={target}
                        hour={this.getHoraUltimaImatge()}
                    />
                    {data === {} ? (
                        <p>{translate(language, 'no_data')}</p>
                    ) : (
                        <div
                            className="mc-widget-content"
                            style={{
                                height: !preview
                                    ? 'calc(100vh - 118px)'
                                    : '100%',
                                // eslint-disable-next-line
                                height: !preview
                                    ? 'calc(100% - 118px)'
                                    : '100%',
                            }}
                        >
                            <div
                                className="map-wrapper"
                                style={{
                                    height: !preview
                                        ? null
                                        : 'calc(100% - 118px)',
                                }}
                            >
                                <Radar data={data} preview={preview} />
                            </div>
                            <RadarLegend language={language} />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    componentDidUpdate() {
        this.getHoraUltimaImatge();
    }

    getHoraUltimaImatge() {
        const dateUltimaImatge = DateTime.fromISO(
            this.props.data.dataUltimaImatge
        );

        return `${dateUltimaImatge.hour}:${dateUltimaImatge.toFormat('mm')}h.`;
    }
}



// WEBPACK FOOTER //
// ./src/widgets/MapaRadar/WidgetMapaRadar.js